import type { User } from 'api/data.types'

type FlagFunction = (user: User, hasForest?: boolean) => boolean

export const hasNeverUsedForest: FlagFunction = (user, hasForest) => {
  if (hasForest !== undefined) {
    return !hasForest
  }
  return !user.reader?.forest
}

export const hasNeverUsedLeague: FlagFunction = hasNeverUsedForest

const Forest = {
  hasNeverUsedForest,
  hasNeverUsedLeague
}

export default Forest
